export const LOAD_WIZARD_STATE = "root.LOAD_WIZARD_STATE";
export const CLEAR_STATE = "root.CLEAR_STATE";
export const INIT_CPQ = "root.INIT_CPQ";
